import { metric } from '@fiverr-private/perseus';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    BQ_CLICKED_CONTACT_SELLER,
    BQ_SIGNUP_CLICK,
    BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS
} from '../bigQueryEvents';
import {
    MP_CLICKED_CONTACT_ME,
    MP_CONTACT_SELLER_OPTIONS_SEND_MESSAGE_SUBMIT_SUCCESS,
    MP_CONTACT_SELLER_OPTIONS_CLICK
} from '../mixPanelEvents';
import { isGigPaused } from '../gigStatus';

/**
 * Returns whether or not to display the contact seller button.
 * @param {object} general
 * @param {boolean} useStickyLayout
 * @returns whether or not to display the contact seller button.
 */
export const shouldRenderContactSeller = ({ general, useStickyLayout }) => {
    const { gigStatus, traffiqed, isLimitedEdition, isOnVacation } = general;
    const isPaused = isGigPaused(gigStatus, traffiqed);

    return useStickyLayout && !isLimitedEdition && !isOnVacation && !isPaused;
};

/**
 * Trigger join modal (or redirects to join page in mobile) on guest's click on contact seller button.
 * @param {object} biEvents
 * @param {object} pathfinderWrapper
 */
export const onGuestClick = ({ biEvents, pathfinderWrapper }) => {
    // The event BQ_SIGNUP_CLICK is reported here because we open the signUpModal manually
    // and not via the autoShowSignUp API
    biEvents.sendBigQueryEvent({ eventName: BQ_SIGNUP_CLICK });
    const { isTouch } = getContext();
    if (!isTouch) {
        window.openSignUpModal();
    } else {
        window.location.assign(pathfinderWrapper.pathfinder('join'));
    }
};

/**
 * Reports a click on the contact seller button.
 * @param {object} biEvents
 * @param {object} pathfinderWrapper
 * @param {string} mixpanelSourceComponent
 * @param {string} bqSourceName
 * @param {string} metricKey
 */
export const reportContactSellerClick = ({
    biEvents,
    mixpanelSourceComponent,
    bqSourceName,
    metricKey
}) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CLICKED_CONTACT_ME,
        params: { 'Source component': mixpanelSourceComponent }
    });

    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_CONTACT_SELLER,
        params: {
            name: bqSourceName,
            eventSource: 'contact_seller_direct'
        }
    });

    metric.count(metricKey);
};

/**
 * Reports success in sending a message
 * @param {object} biEvents
 */
export const reportSendMessageSubmitSuccess = (biEvents) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_SEND_MESSAGE_SUBMIT_SUCCESS
    });
};

/**
 * Reports the contact seller options click event
 * @param {object} biEvents
 * @param {string} eventSource The component's source name
 */
export const reportContactSellerOptionsClick = (biEvents, eventSource) => {
    biEvents.sendMixPanelEvent({
        eventName: MP_CONTACT_SELLER_OPTIONS_CLICK
    });

    biEvents.sendBigQueryEvent({
        eventName: BQ_CLICKED_ON_CONTACT_SELLER_OPTIONS,
        params: { name: eventSource }
    });
};

/**
 * Redirects to an inbox conversation
 * @param {object} pathfinderWrapper
 */
export const redirectToInboxConversation = (pathfinderWrapper) => {
    const { pathParameters } = getContext();
    const { username } = pathParameters;
    const inboxConversationUrl = pathfinderWrapper.pathfinder('conversation', { id: username });
    window.location.assign(inboxConversationUrl);
};
